import type {
  IOrderMSServiceDocument,
  IOrderMSServiceUploadDocument,
} from './../types/document/models'
import { makeDocumentService } from '~/cynqueModules/factoriesForServices/documents'

export const {
  createDocument: createOrderMSServiceDocument,
  updateDocument: updateOrderMSServiceDocument,
  deleteDocument: deleteOrderMSServiceDocument,
} = makeDocumentService<IOrderMSServiceDocument, IOrderMSServiceUploadDocument>(
  '/api/ordermsservicedocuments',
  'orderMSServiceDocument'
)
